"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpellCheckerLayoutChangesListener = exports.SpellCheckerModelChangesListener = void 0;
var enums_1 = require("../model/changes/enums");
var rich_utils_1 = require("../model/rich-utils");
var SpellCheckerModelChangesListener = (function () {
    function SpellCheckerModelChangesListener(spellChecker) {
        this.spellChecker = spellChecker;
    }
    SpellCheckerModelChangesListener.prototype.modelChanged = function (change) {
        switch (change.type) {
            case enums_1.ModelChangeType.InlinePictureInserted:
            case enums_1.ModelChangeType.AnchoredPictureInserted:
            case enums_1.ModelChangeType.ParagraphInserted:
            case enums_1.ModelChangeType.AnchoredTextBoxInserted: {
                this.spellChecker.onModelIntervalChanged(change.position, 1, true);
                break;
            }
            case enums_1.ModelChangeType.SimpleRunInserted: {
                this.spellChecker.onModelIntervalChanged(change.position, change.length, change.length == 1 && rich_utils_1.RichUtils.isWhitespace.test(change.text));
                break;
            }
            case enums_1.ModelChangeType.AnchorObjectRemoved: {
                break;
            }
            case enums_1.ModelChangeType.IntervalRemoved: {
                this.spellChecker.onModelIntervalChanged(change.interval.start, -change.interval.length, false);
                break;
            }
            case enums_1.ModelChangeType.ParagraphMerged: {
                this.spellChecker.onModelIntervalChanged(change.position, -1, false);
                break;
            }
        }
    };
    return SpellCheckerModelChangesListener;
}());
exports.SpellCheckerModelChangesListener = SpellCheckerModelChangesListener;
var SpellCheckerLayoutChangesListener = (function () {
    function SpellCheckerLayoutChangesListener(spellChecker) {
        this.spellChecker = spellChecker;
    }
    SpellCheckerLayoutChangesListener.prototype.NotifyPagesReady = function (_pageChanges) {
        this.spellChecker.onLayoutChanged();
    };
    SpellCheckerLayoutChangesListener.prototype.NotifyFullyFormatted = function (_pageCount) { };
    ;
    return SpellCheckerLayoutChangesListener;
}());
exports.SpellCheckerLayoutChangesListener = SpellCheckerLayoutChangesListener;
